import { Text, ButtonCard as VuiButtonCard } from '@village/ui';
import { Banner as BaseBanner } from 'components/banner';
import { rem } from 'polished';
import styled from 'styled-components';

const Container = styled.div`
    display: inline-flex;
    flex-direction: column;
    gap: ${rem(24)};
    width: 100%;
`;

const Wrapper = styled.div`
    display: inline-flex;
    flex-direction: column;
    gap: ${rem(24)};
`;

const ButtonCard = styled(VuiButtonCard)<{ $isPreSelected: boolean }>`
    font-family: CeraPro, arial, sans-serif;
    align-content: center;
    height: ${rem(88)};
    border-width: 2px;
    border-style: solid;
    border-color: ${({ theme, $isPreSelected }) =>
        $isPreSelected
            ? theme.vui.component.buttonCard.selected.borderColor
            : theme.vui.component.buttonCard.default.borderColor};
    border-radius: ${({ theme }) => theme.vui.component.buttonCard.default.borderRadius};
    padding: ${rem(24)} ${rem(20)};

    & svg {
        color: ${({ theme }) => theme.vui.colors.icon.default};
    }

    @media (hover: hover) {
        &:hover {
            border-color: ${({ theme }) => theme.vui.component.buttonCard.hover.borderColor};
        }
    }

    &:active {
        border-color: ${({ theme }) => theme.vui.component.buttonCard.selected.borderColor};
    }
`;

const DateOfBirth = styled(Text)`
    font-family: CeraPro, arial, sans-serif;
    color: ${({ theme }) => theme.vui.colors.text.secondary};
`;

const Banner = styled(BaseBanner)`
    border-radius: ${rem(8)};
`;

const AvatarInitials = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: ${rem(48)};
    height: ${rem(48)};
    border-radius: 50%;
    background-color: ${({ theme }) => theme.vui.colors.background.surface.critical.default};
    color: #d80032;
`;

export { DateOfBirth, Container, ButtonCard, Wrapper, Banner, AvatarInitials };
